import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocationPackageForm from './LocationPackageForm'

const LocationPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.locationpackages.createPackage'}>
    <Create>
      <LocationPackageForm />
    </Create>
  </SectionWrapper>
)

export default LocationPackageCreate
